import { render } from "./IconRe.vue?vue&type=template&id=4ca395cf"
import script from "./IconRe.vue?vue&type=script&lang=js"
export * from "./IconRe.vue?vue&type=script&lang=js"

import exportComponent from "/Users/animatik/Sites/Vitalhit/Pay/id/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__